import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Result() {
  return (
    <section className="result_par result_onsite p-100 text_onsite">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto resp_order text-center"
          >
            <div className="result_img_onsite">
              <StaticImage
                src="../../../images/case-studies/onsite/conclusion.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={601}
                height={744}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              <span>Conclusion</span>
            </h2>
            <p>
              OnSite Social has successfully achieved its goals with the
              dedicated efforts of TekRevol in creating a unique platform that
              harnesses the power of location-based technology to connect users
              in real-time. TekRevol played a pivotal role in conceptualizing,
              designing, and developing the app, ensuring that it seamlessly
              integrates advanced features and functionalities.
            </p>
            <p>
              The app's positive impact on networking, social opportunities, and
              relationship-building underscores its value in today's digital
              age. OnSite Social is not just an app; it's a catalyst for
              real-world connections, and TekRevol's expertise was instrumental
              in bringing this vision to life.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Result;
